import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-43d51a80")

_pushScopeId("data-v-43d51a80")
const _hoisted_1 = {
  key: 2,
  class: "list-item-video"
}
const _hoisted_2 = {
  key: 4,
  class: "list-item-desc"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImgContainer = _resolveComponent("ImgContainer")
  const _component_HotspotSwiper = _resolveComponent("HotspotSwiper")
  const _component_HotspotSpecial = _resolveComponent("HotspotSpecial")
  const _component_HotspotDownload = _resolveComponent("HotspotDownload")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (m, n) => {
    return (_openBlock(), _createBlock("div", {
      class: "list-item",
      key: n
    }, [
      (m.type === 1)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: `list-item-image ${m.shadow ? 'shadow' : ''}`
          }, [
            _createVNode(_component_ImgContainer, {
              src: m.img
            }, null, 8, ["src"])
          ], 2))
        : (m.type === 2)
          ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(m.intro, (p, q) => {
              return (_openBlock(), _createBlock("p", { key: q }, _toDisplayString(p), 1))
            }), 128))
          : _createCommentVNode("", true),
      (m.type === 5)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("video", {
              src: m.video,
              poster: m.poster ? m.poster : '',
              controls: "controls",
              preload: "auto",
              "x5-playsinline": "true",
              playsinline: "true",
              "webkit-playsinline": "true",
              onPlay: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVideoPlay && _ctx.handleVideoPlay(...args)))
            }, null, 40, ["src", "poster"])
          ]))
        : _createCommentVNode("", true),
      (m.type === 3)
        ? (_openBlock(), _createBlock(_component_HotspotSwiper, {
            key: 3,
            list: m.swiper,
            isImgNeedBorder: _ctx.isSwiperImgNeedBorder,
            onAudiobgstop: _ctx.handleVideoPlay
          }, null, 8, ["list", "isImgNeedBorder", "onAudiobgstop"]))
        : _createCommentVNode("", true),
      (m.desc)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("p", null, _toDisplayString(m.desc), 1)
          ]))
        : _createCommentVNode("", true),
      (m.type === 4)
        ? (_openBlock(), _createBlock("div", {
            key: 5,
            class: `list-item-nav ${m.center ? 'center' : ''}  ${
        m.noLeft ? 'no-left' : ''
      }  ${m.noMargin ? 'no-margin' : ''}`
          }, [
            _createVNode("span", null, _toDisplayString(m.nav), 1)
          ], 2))
        : _createCommentVNode("", true),
      (m.type === 6)
        ? (_openBlock(), _createBlock(_component_HotspotSpecial, {
            key: 6,
            data: m
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (m.type === 7)
        ? (_openBlock(), _createBlock(_component_HotspotDownload, {
            key: 7,
            class: "list-item-dowlonad"
          }))
        : _createCommentVNode("", true)
    ]))
  }), 128))
})